module.exports = __webpack_public_path__ + "img/rank.ed7e12d9.jpg";